export class LoggerService {

    constructor() {

    }

    log(message: string) {
        // if (this.enable) {
        //     console.log(`LoggerService: ${message}`);
        // }
    }
}